<template>
  <div>

    <div class="steps">


      <div class="box">
        <img class="img1" src="../../../../static/images/icon/import_icon_upload_sel.png" alt="">
        <p class="steps_title">上传数据</p>
      </div>
      <div class="line"></div>
      <div class="box">
        <img class="img2" src="../../../../static/images/icon/import_icon_preview_sel.png" alt="">
        <p class="steps_title">数据预览</p>
      </div>
      <div class="line"></div>
      <div class="box">
        <img class="img3" src="../../../../static/images/icon/import_icon_suc_sel.png" alt="">
        <p class="steps_title">导入完成</p>
      </div>
    </div>
    <div v-if="statu === 1">
      <div class="upload">
        <div class="upload_border">
          <a-upload
            name="file"
            :action="uploadUrl"
            accept=".xls,.xlsx,"
            :before-upload="handleChange"
            :remove="remove"
            v-if="uploadSuccess"
          >
            <!--            <a-icon width="20px" type="upload" />-->
            <a-icon :type="upLoading ? 'loading' : 'upload'" />
            <br>
            <a-button v-if="!upLoading" style="border:none;background:none;font-size:10px;margin-top:10px">点击此处上传文件</a-button>
          </a-upload>
          <div class="fileInfo" v-else>
            <img src="../../../../static/images/accept.png" alt="">
            <div>
              <p class="fileName">{{ accept.name }}文件</p><br>
              <p class="fileSize">{{ accept.size }}kb</p>
            </div>
            <a-icon type="delete" @click="remove" style="margin-left: 20px" />
          </div>
          <p v-if="!uploadSuccess" style="float:right">
            成功导入<span style="color:#92CF7C">{{ dataList.length }}</span>条数据，失败<span
            style="color:#D73030">{{ errorInfo.failCount }}</span>条数据</p>
        </div>
      </div>
      <div v-if="uploadFail" style="margin:30px auto 0;width:20%;text-align:center;">
        <p style="color:#D43030;font-size:12px">请下载失败数据，然后再次导入</p>
        <p style="color:#2A82E4;font-size:12px;font-weight:800;margin-top:10px">
          <a :href="errorInfo.failExcelUrl"
             target="_blank">
            <a-icon type="download" />
            下载失败数据</a>
        </p>
      </div>
      <div v-else class="downP">
        <a :href="`${path}template.xlsx`" download="设备导入模板.xlsx" ><a-icon type="download" />下载模板</a>
      </div>
      <div style="width:30%;margin:50px auto;display:flex;justify-content: space-between;">
        <a-button class="upload_button" @click="baclList" style="background:none;border:1px solid #A4A4A4;color:#A4A4A4">
          返回列表
        </a-button>
        <a-button class="upload_button"  :disabled="!dataList.length" @click="look" style="background:#013C7E;border:none;color:#fff">下一步</a-button>
      </div>
    </div>
    <div v-if="statu === 2">
      <div class="page-main">
        <a-table
          class="table_data"
          :columns="columns"
          :dataSource="dataList"
          rowKey="index"
          style="margin-top:30px;"
        >
        </a-table>
        <div style="width:40%;margin:50px auto;display:flex;justify-content: space-between;">
          <a-button :loading="loading" class="upload_button" @click="baclList"
                    style="background:none;border:1px solid #A4A4A4;color:#A4A4A4">
            返回列表
          </a-button>
          <a-button :loading="loading" class="upload_button" @click="previous"
                    style="background:none;border:1px solid #A4A4A4;color:#A4A4A4">
            上一步
          </a-button>
          <a-button :loading="loading" class="upload_button" @click="StartImporting"
                    style="background:#013C7E;border:none;color:#fff">开始导入
          </a-button>
        </div>
      </div>
    </div>
    <div v-if="statu === 3">
      <div class="upload">
        <div class="upload_border">
          <a-icon style="font-size:20px" type="reload" />
          <p style="font-size:12px;margin-top:10px;">xxx导入中</p>
        </div>
      </div>
      <div style="width:30%;margin:50px auto;display:flex;justify-content: space-between;">
        <button class="upload_button" @click="baclList" style="background:none;border:1px solid #A4A4A4;color:#A4A4A4">
          返回列表
        </button>
        <button class="upload_button" @click="look" style="background:#A6A6A6;border:none;color:#fff">完成</button>
        <!-- <button class="upload_button" @click="look" style="background:#20253F;border:none;color:#fff">完成</button> -->
      </div>
    </div>
    <div v-if="statu === 4">
      <div class="upload">
        <div class="upload_border">
          <a-icon style="font-size:20px" type="check" />
          <p style="font-size:12px;margin-top:10px;">xxx导入成功</p>
        </div>
      </div>
      <div style="width:30%;margin:50px auto;display:flex;justify-content: space-between;">
        <button class="upload_button" @click="baclList" style="background:none;border:1px solid #A4A4A4;color:#A4A4A4">
          返回列表
        </button>
        <button class="upload_button" @click="look" style="background:#20253F;border:none;color:#fff">完成</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiUrl } from "@/config/api.config.js";
import { tips } from "@/utils/util";

export default {
  data() {
    return {
      path:process.env.BASE_URL,
      uploadUrl: ApiUrl.uploadUrl,
      uploadSuccess: true,
      uploadFail: false,
      upLoading: false,
      errorInfo: {
        failCount: 0,
        failExcelUrl: undefined
      },

      files: [],

      accept: {
        name: "",
        size: ""
      },
      statu: 1,
      naxt: "下一步",
      columns: [
        {
          title: "MAC地址",
          align: "center",
          key: "deviceCode",
          dataIndex: "deviceCode"
        },
        {
          title: "协议号",
          align: "center",
          key: "protocolVersion",
          dataIndex: "protocolVersion"
        }
      ],
      dataList: [],
      loading: false,
      failCount: 0// 数据解析之后 错误数据的数量
    };
  },
  methods: {

    parse: async function(file) {
      const formData = new FormData();
      formData.append("file", file);
      // this.statu = 3;
      let cancel = (c) => c;
      this.upLoading = true;
      const res = await this.$post("bluetoothlight/web/devices/parse", formData, cancel);
      this.upLoading = false;


      const { resultStatus, resultData, errorMessage } = res || {};

      if (!resultStatus) {
        // this.statu = 1;
        tips(this, false, errorMessage || "数据解析失败,请确认数据是否合理");
        return false;
      }
      this.accept = file;
      this.uploadSuccess = false;  //导入请求之后
      const { successList, successCount, failCount, failExcelUrl } = resultData;
      this.uploadFail = failCount > 0;
      this.errorInfo = { failCount, failExcelUrl }; // 下载失败的url
      if (!successCount) {
        tips(this, false, errorMessage || "数据解析失败");
        this.statu = 1;
        return false;
      }

      this.dataList = successList.map((el, index) => {
        return { ...el, index };
      });
      // this.statu = 2;

    },
    remove() {
      if (this.upLoading) return false;
      Object.assign(this, {
        files: [],
        statu: 1,
        uploadSuccess: true,
        dataList: []
      });

    },
    handleChange(file) {


      // if (!/^\w{1,}((\.xls)|(\.xlsx)){1}$/.test(file.name)) {
      //   tips(this, false, '请上传正确的文件')
      //   return false;
      // }

      this.parse(file);
      return false;
      // if (info.file.status !== "uploading") {
      //   console.log(info.file, info.fileList);
      //   this.uploadSuccess = !this.uploadSuccess;
      //   this.accept = info.file;
      //   console.log(this.accept);
      // }
      // if (info.file.status === "done") {
      //   this.$message.success(`${info.file.name} file uploaded successfully`);
      // } else if (info.file.status === "error") {
      //   this.uploadFail = !this.uploadFail;
      //   this.$message.error(`${info.file.name} file upload failed.`);
      // }
    },
    baclList() {
      this.$router.push({
        path: "/equipment_list"
      });
    },
    look() {
      if (!this.uploadSuccess) {
        this.statu = 2;
      } else {
        this.$message.error("文件错误，请重新上传！");
      }
    },
    previous() {
      this.statu = 1;
    },
    StartImporting: async function() {
      // this.statu = 3;

      // this.
      if (this.loading) return false;
      this.loading = true;
      const res = await this.$post("bluetoothlight/web/devices/import", {
        deviceList: this.dataList
      });
      setTimeout(() => this.loading = false, 1000);
      tips(this, res.resultStatus, res.errorMessage);
      if (res.resultStatus) {
        setTimeout(() => this.remove(), 1000);
      }
    }
  }
};
</script>


<style lang="less">
.downP {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  padding: 15px;
}

.steps {
  width: 80%;
  height: 150px;
  border-radius: 10px;
  box-shadow: 5px 8px 30px #BCBCBC;
  background-color: #fff;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 5px;
  display: flex;
  justify-content: space-around;

  // position: relative;
  // left: 10%;
  .line {
    width: 300px;
    height: 1px;
    background-color: #C3C3C3;
    position: relative;
    top: 80px;
    left: -5px;
  }

  .box {
    text-align: center;
    width: 200px;
    height: 110px;
    margin: 40px 0;
    //padding: 0 80px;
    // border-bottom: 3px solid #2A82E4;
    .steps_title {
      font-size: 18px;
      color: #2A82E4;
    }

    img {
      margin: 10px auto;
      display: block;
    }

    .img1 {
      width: 36px;
      height: 27px;
      //height: 58px;
    }

    .img2 {
      width: 29px;
      height: 32px;
      //height: 58px;
    }

    .img3 {
      width: 36px;
      height: 36px;
      //height: 58px;
    }
  }

  .ant-steps {
    width: 100%;
  }

  .ant-steps-item-icon, .ant-steps-item-content {
    display: block;
    width: 100%;
    text-align: center;

    .ant-steps-item-title::after {
      top: 0;
    }
  }
}

.upload {
  width: 500px;
  height: 200px;
  background-color: #fff;
  box-shadow: 5px 8px 30px #BCBCBC;
  border-radius: 5px;
  margin: 150px auto 0;
  padding: 10px 10px;
  box-sizing: border-box;

  &_border {
    width: 480px;
    height: 180px;
    border: 3px dotted #888888;
    border-radius: 5px;
    text-align: center;
    padding: 50px 10px;
    box-sizing: border-box;
  }

  &_button {
    border-radius: 5px;
    font-size: 12px;
    width: 100px;
    height: 30px;
  }
}

.fileInfo {
  display: flex;
  padding: 10px;
  text-align: left;
  align-items: center;

  img {
    margin-right: 30px;
  }

  .fileName {
    font-size: 14px;
  }

  .fileSize {
    font-size: 12px;
  }
}
</style>
